import React from "react";
import "./index.less";

import bottomLogin from '../../assets/newVersion/bottom_logo.png';
import locationIcon from '../../assets/newVersion/location-icon.png';
import phoneIcon from '../../assets/newVersion/phone-icon.png';
import emailIcon from '../../assets/newVersion/email-icon.png';
import dafangBottom from '../../assets/newVersion/dafang-bottom.svg';
import police from '../../assets/newVersion/police.png';

import locationSvg from '../../assets/newVersion/bottom/location.svg';
import emailSvg from '../../assets/newVersion/bottom/email.svg';
import phoneSvg from '../../assets/newVersion/bottom/phone.svg';
import { Link } from "react-router-dom";

import LazyImage from "../LazyImage";
import { url } from "inspector";
// 导航栏数据
const navData = [
  {
    title: '智能出行',
    link: 'smart-travel',
    items: [{ label: '智能座舱', url: 'zhinengzuocang' }, { label: '智能驾驶', url: 'zhinengjiashi' }, { label: '核心优势', url: 'hexinyoushi' }, { label: '合作伙伴', url: 'hezuohuoban' }]
  },
  {
    title: '数智企业',
    link: 'enterprise',
    items: [{ label: '企业地图', url: 'qiyeditu' }, { label: '室内地图', url: 'shineiditu' }, { label: '新能源充电站选址、运营', url: 'xinnengyuanxuanzhi' }]
  },
  {
    title: '关于大方',
    link: 'about',
    items: [{ label: '企业介绍', url: 'qiyejieshao' }, { label: '合作伙伴', url: 'hezuohuoban' }, { label: '荣誉与资质', url: 'rongyuyuzizhi' }, { label: '合规与诚信', url: 'heguiyuchengxin' }]
  },
  {
    title: '联系我们',
    link: 'contact',
    items: [{ label: '联系我们', url: 'lianxiwomen' }, { label: '加入我们', url: 'jiaruwomen' }]
  }
];
const Footer: React.FC = () => (
  <footer className="footer">
    <div className="scroll-sixth">
      <div className="info">
        <div className="left">
          <Link to="/"><img src={bottomLogin} alt="Logo" className="bottom-logo" /></Link>
          {/* <div className="text-info">
            <div className="ti-title">北京大方云图科技有限公司</div>
            <div className="ti-msg">Beijing DafangYuntu.Technology Co., Ltd</div>
          </div> */}
        </div>

        <div className="right">
          {navData.map((nav, index) => (
            <div className="right-item" key={index}>
              <Link className="right-item-title" to={nav.link}>
                {nav.title}
              </Link>
              <div className="right-item-content">
                {nav.items.map((item, itemIndex) => (
                  <Link
                    className="right-item-item"
                    key={itemIndex}
                    to={`/${nav.link}#${item.url}`}
                  >
                    {item.label}
                  </Link>
                ))}
              </div>
            </div>
          ))}
          <div className="contact-info right-item">
            <div className="br-item">
              <div className="right-item-title">电话</div>
              <div className="text">131 2116 2261</div>
            </div>
            <div className="br-item">
              <div className="right-item-title">地址</div>
              <div className="text">北京市朝阳区创远路26号院1号楼4层402</div>
            </div>
            <div className="br-item">
              <div className="right-item-title">邮箱</div>
              <div className="text" style={{ fontFamily: 'PingFang SC' }}>Dfpublic@dafangyuntu.com</div>
            </div>
          </div>
        </div>
      </div>
      {/* <div className="six-bottom">
        <img src={dafangBottom} alt="" className="dafang-img" />
      </div> */}

      <div className="about-bottom">
        <div className="a-left">©2021 北京大方云图科技有限公司</div>
        <div className="a-right">
          <img src={police} alt="" className="police" />
          ©京ICP备2021027217号
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
